import { render, staticRenderFns } from "./SosModal.vue?vue&type=template&id=4c7056a2"
import script from "./SosModal.vue?vue&type=script&lang=js"
export * from "./SosModal.vue?vue&type=script&lang=js"
import style0 from "./SosModal.vue?vue&type=style&index=0&id=4c7056a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports